import React from 'react'
import { Link } from 'react-static'

import SectionTitle from 'components/Section-Title'
import ColorBar from 'components/Color-Bar'
import TeamMember from 'components/Team-Member'

class Team extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ColorBar />

        <div className="container">
          <SectionTitle
            icon="icon-team.svg"
            title="The Team"
            titleClasses="section-title__copy--grey"
          />

          <div className="layout layout--content layout--pb-lg">
            <div className="layout__item layout__item--half">
              <TeamMember
                name="Colin Whelan"
                position="Director"
                image="team-colin-whelan.jpg"
                bio="A founding partner of GDL alongside Chris Kelly. Colin’s formative years were spent with Stiles Harold Williams in their Crawley and London office serving developer clients in the south east and throughout the UK. Following 4 years with Simons Estates Glenbeigh Developments was formed. Colin’s focus is on south east development and investment opportunities primarily for commercial but also mixed use or pure residential."
                email="colinw@glenbeighltd.com"
                tel="07801 295 777"
              />
            </div>
            <div className="layout__item layout__item--half">
              <TeamMember
                name="Chris Kelly"
                image="team-chris-kelly.jpg"
                bio="A founding partner of GDL alongside Colin Whelan. Chris’s formative years were spent with Barclays Bank and Homebase and thereafter 9 years heading Simons Estates London office before forming GDL. Chris’s early focus was on retail and mixed use schemes and more latterly larger industrial and employment parks in our target area of Kent to Dorset outside the M25"
                email="chrisk@glenbeighltd.com"
                tel="07787 537 041"
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Team;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Team.js